import { createStyles, SimpleGrid, Card, Image, Text, Container, AspectRatio } from '@mantine/core';
import {Link} from 'react-router-dom'

import myData from '../assets/database.json'

const gameData = myData.products;

const useStyles = createStyles((theme) => ({
  card: {
    transition: 'transform 150ms ease, box-shadow 150ms ease',

    '&:hover': {
      transform: 'scale(1.01)',
      boxShadow: theme.shadows.md,
    },
  },

  title: {
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    fontSize : 28,
    fontWeight: 700,
  },
}));

export function ArticlesCardsGrid() {
  const { classes } = useStyles();
  const cards = gameData.map((article) => (
    <Link to = "/product" state={{article}} style={{textDecoration:'none'}}>
    <Card key={article.title} p="md" radius="md" component="a" href="#" className={classes.card}>
      <AspectRatio ratio={1920 / 1080}>
        <Image src={article.imageList[0].value} withPlaceholder/>
      </AspectRatio>
      <Text className={classes.title} mt={5}>
        {article.title}
      </Text>
      <Text color="dimmed" size="xs" transform="uppercase" weight={700} mt="md">
        {article.intro}
      </Text>
    </Card>
    </Link>
  ));

  return (
    <Container py="xl">
      <SimpleGrid cols={2} breakpoints={[{ maxWidth: 'sm', cols: 1 }]}>
        {cards}
      </SimpleGrid>
    </Container>
  );
}